import React from 'react'
import { TransitionMotion, spring } from 'react-motion'
import './styles.sass'

const SLIDE_AMOUNT = 70
const rmConfig = {
  stiffness: 240,
  damping: 24
}

export default class SlideTransition extends React.Component {
  willEnter = () => {
    return {
      opacity: 0,
      // Slides the correct way based on
      // whether we're going forwards or backwards
      x: this.props.invert ? -SLIDE_AMOUNT : SLIDE_AMOUNT
    }
  }

  willLeave = () => {
    return {
      opacity: spring(0),
      x: spring(this.props.invert ? SLIDE_AMOUNT : -SLIDE_AMOUNT, rmConfig)
    }
  }

  getStyles = () => {
    return {
      opacity: spring(1),
      x: spring(0, rmConfig)
    }
  }

  render () {
    const { children, wrapper: Wrapper, transitionKey } = this.props
    return (
      <TransitionMotion
        styles={[{
          key: transitionKey,
          style: this.getStyles(),
          data: children
        }]}
        willEnter={this.willEnter}
        willLeave={this.willLeave}
      >
        {(interpolated) => (
          <div>
            {interpolated.map(({ key, style, data }) => (
              <Wrapper
                key={`${key}-transition`}
                className="slide-transition"
                style={{
                  position: 'absolute',
                  width: '100%',
                  overflow: 'visible',
                  opacity: style.opacity,
                  transform: `translateX(${style.x}%)`
                }}
              >
                {data}
              </Wrapper>
            ))}
          </div>
        )}
      </TransitionMotion>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/components/SlideTransition/index.jsx